<template>
  <div>
    <!-- Step2  -->
    <!-- {{ $route.params}} -->
    <!-- breadcrumbs  -->
    <div class="py-4 flex items-center">
      <div><v-btn text to="/home/buyers-guide">Buyer's Guide</v-btn></div>
      <div class="px-2">/</div>
      <div class="pl-2">{{ $route.params.info.item }}</div>
    </div>

    <div class="px-10">
       <!-- <pre>
         {{content}}
       </pre> -->
      <div class="flex flex-col border border-gray-700 text-white">
      
        <AccordionChild
          class="text-center accordion1"
          v-for="(item, i) in content"
          :key="i"
          :guide_item="item"
        ></AccordionChild>
      </div>
    </div>
   <!-- <pre> {{ content }}</pre> -->
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import AccordionChild from "@/screens/buyersGuideScreen/TitleTransferScreen";
// import AccordionChild from "@/screens/buyersGuideScreen/FinancingSchemeScreen";
import TypesOfPayment from "@/screens/buyersGuideScreen/MoveInTurnoverScreen";
export default {
  data() {
    return {
      // modesOfPayment:[
      //   {
      //     title:"Types of Payment Facilities",
      //   },
      //   {
      //     title:"Payment Facility per Transaction"
      //   },
      //   {
      //     title:"List of Payment Facilities"
      //   },
      //   {
      //     title:"Reminders of Payments"
      //   }
      // ],
      content: [],
      subcontent: [],
    };
  },
  components: {
    AccordionChild,TypesOfPayment
  },
  // watch: {
  //   "$route.name": {
  //     handler() {
  //       this.get_menus(this.$route.params.info.buyers_guide_menu_id);
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    // get_menus(i) {
    //   let data = {
    //     id: i,
    //   };
    //   axios.post("/buyers_guide/get_children", data).then((res) => {
    //     this.content = res.data.filter(x=>x.buyers_guide_menu_id!=36
    //       && x.buyers_guide_menu_id!=9
    //     )
    //   });
    // },

    get_subcontents(i) {
      let data = {
        id: i,
      };
      axios.post("/buyers_guide/content", data).then((res) => {
        this.content = res.data;
      });
    },
  },
};
</script>

<style scoped>
.accordion1 {
  background: #033a87;
  background-image: #033a87;
}
.accordion1:hover {
  background: linear-gradient(-10deg, #7e1e06, red);
}
  table{
    border: black solid 1px;
  }
  td{
    border: gray solid 1px;
    padding:4px;
  }
</style>
